import { Collections } from "@diacare/common/models/collections";
import { ModelConfig } from "@litbase/admin";
import { ProjectionObject } from "@litbase/core";
import { notificationConfig } from "./notification";
import { questionConfig } from "./question";
import { userConfig } from "./user-config";

export interface ExtendedModelConfig extends ModelConfig {
  queryFields: ProjectionObject;
}

export const modelConfigs = {
  [Collections.USERS]: userConfig,
  [Collections.QUESTIONS]: questionConfig,
  [Collections.NOTIFICATIONS]: notificationConfig,
};
